import { HaN } from "./shell/HaN";
import type { HereAndNowTab } from "./tabs";

export const HereAndNowRevamp = ({ tab }: { tab: HereAndNowTab }) => {
  return <HaN.Page tab={tab} />;
};
